__turbopack_context__.v({
  "button": "fallback-module-scss-module__CV8VuG__button",
  "content": "fallback-module-scss-module__CV8VuG__content",
  "description": "fallback-module-scss-module__CV8VuG__description",
  "lockWrapper": "fallback-module-scss-module__CV8VuG__lockWrapper",
  "title": "fallback-module-scss-module__CV8VuG__title",
  "wrapper": "fallback-module-scss-module__CV8VuG__wrapper",
});
